/**
 * Root `id` for routed pages and major modals under `src/pages/`.
 * Import the key you need: `id={pageRootTestIds.designs}`.
 * Convention: `page-<kebab-slug>`.
 */
export const pageRootTestIds = {
  dashboard: "page-dashboard",
  issuedCertificates: "page-issued-certificates",
  forgotPassword: "page-forgot-password",
  approvalDashboard: "page-approval-dashboard",
  organisation: "page-organisation",
  activateAccount: "page-activate-account",
  applicantProfile: "page-applicant-profile",
  resetPassword: "page-reset-password",
  applicantContinueApplication: "page-applicant-continue-application",
  auditApplicationReview: "page-audit-application-review",
  notifyConfirmSendModal: "page-notify-confirm-send-modal",
  drafts: "page-drafts",
  legacyIssuance: "page-legacy-issuance",
  cloneEmailCustomizeStep: "page-clone-email-customize-step",
  batch: "page-batch",
  legacyCertificateDetail: "page-legacy-certificate-detail",
  cloneEmailTemplateBuilder: "page-clone-email-template-builder",
  editIssuerTemplate: "page-edit-issuer-template",
  applicantDashboard: "page-applicant-dashboard",
  designs: "page-designs",
  landing: "page-landing",
  auditApplications: "page-audit-applications",
  verificationApprovals: "page-verification-approvals",
  categories: "page-categories",
  adminUserOrganisation: "page-admin-user-organisation",
  allCertificatesPerCategory: "page-all-certificates-per-category",
  transactionDetails: "page-transaction-details",
  notifyRecipients: "page-notify-recipients",
  transaction: "page-transaction",
  auditLogs: "page-audit-logs",
  printRequest: "page-print-request",
  settingTemplate: "page-setting-template",
  notifyEmailPreviewModal: "page-notify-email-preview-modal",
  settingEmailAddress: "page-setting-email-address",
  settingButton: "page-setting-button",
  batchTransaction: "page-batch-transaction",
  credentialPreview: "page-credential-preview",
  tenant: "page-tenant",
  certificateOnboarding: "page-certificate-onboarding",
  failedEmailIdentity: "page-failed-email-identity",
  applicantApplications: "page-applicant-applications",
  programme: "page-programme",
  tenantOrganisation: "page-tenant-organisation",
  verifierApprovals: "page-verifier-approvals",
  addDrafts: "page-add-drafts",
  auditReviewedApplications: "page-audit-reviewed-applications",
  auditReviewedDetails: "page-audit-reviewed-details",
  workspaceCertificates: "page-workspace-certificates",
  successEmailIdentity: "page-success-email-identity",
  cloneEmailSelectStep: "page-clone-email-select-step",
  legacyPendingIssuance: "page-legacy-pending-issuance",
  notifyCertificatePreviewModal: "page-notify-certificate-preview-modal",
  verifierApprovalDetails: "page-verifier-approval-details",
  certificateDetails: "page-certificate-details",
  emailTemplateEditor: "page-email-template-editor",
  applicantCredentials: "page-applicant-credentials",
  allTransactions: "page-all-transactions",
  printPdf: "page-print-pdf",
  certificateIssue: "page-certificate-issue",
  viewAllDrafts: "page-view-all-drafts",
  walletOffer: "page-wallet-offer",
  issuerOnboarding: "page-issuer-onboarding",
};
